"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Divider_1 = __importDefault(require("@material-ui/core/Divider"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var Card_1 = __importDefault(require("../../../Card"));

var Header_1 = __importDefault(require("../../../Card/Header"));

var Image_1 = __importDefault(require("../../../Card/Image"));

var Section_1 = __importDefault(require("../../../Card/Section"));

require("./style.scss");
/**
* Info Card for a `MapMarker` Component.
*/


var MapInfoCard = function MapInfoCard(_a) {
  var active = _a.active,
      data = _a.data,
      style = _a.style;
  var description = data.description,
      details = data.details,
      image = data.image,
      label = data.label;
  return react_1.default.createElement("div", {
    className: "story-map__info-card",
    style: style
  }, react_1.default.createElement(Card_1.default, null, react_1.default.createElement(Header_1.default, {
    text: label
  }), active && react_1.default.createElement("div", null, description && react_1.default.createElement("div", {
    className: "map-detail-small"
  }, description), image && react_1.default.createElement(Image_1.default, {
    alt: label,
    src: image
  }), details && details.map(function (_a) {
    var detailDesc = _a.description,
        detailImg = _a.image,
        detailLabel = _a.label,
        title = _a.title;
    return react_1.default.createElement(Section_1.default, {
      key: detailLabel + "-" + title
    }, react_1.default.createElement("div", {
      style: {
        fontSize: '75%',
        fontWeight: 400
      }
    }, title), react_1.default.createElement(Divider_1.default, null), react_1.default.createElement("div", {
      style: {
        fontSize: '60%',
        paddingBottom: 5
      }
    }, detailLabel), detailDesc && react_1.default.createElement("div", {
      className: "map-detail-small"
    }, detailDesc), detailImg && react_1.default.createElement(Image_1.default, {
      alt: detailLabel,
      src: detailImg
    }));
  }))));
};

MapInfoCard.propTypes = {
  /** Determines if the current marker is at this position. */
  active: prop_types_1.default.bool,

  /** Information to render in the `Card` */
  // eslint-disable-next-line react/forbid-prop-types
  data: prop_types_1.default.object.isRequired,

  /** Styling object of the `Card` */
  // eslint-disable-next-line react/forbid-prop-types
  style: prop_types_1.default.object
};
MapInfoCard.defaultProps = {
  active: false,
  style: {}
};
exports.default = MapInfoCard;